<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <!-- This part is for rendering bill number list to search for bill wise purchase return data -->
      <div class="p-fluid p-formgrid p-grid p-mt-2" v-if="this.loadPage">
        <div class="p-field p-col-12 p-md-2">
          <label for="billNumber">Bill Number</label>
          <dropdown
            v-model="billPrefix"
            :options="billNumberList"
            optionLabel="billPrefix" filterMatchMode='contains'
            placeholder="Select bill no"
            id="billNumber"></dropdown>
        </div>
        <div class="p-field p-col-12 p-md-1 p-mt-5">
          <Button class="p-button-raised p-button-rounded" @click="searchInventoryDetailsByBillNo"
                  label="Search" icon="pi pi-search"/>
        </div>
      </div>
      <!-- This part is for rendering bill number list to search for bill wise purchase return data -->
      <div v-if="!this.loadPage">
        <form>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-2">
              <label for="returnDate">Return Date</label>
              <date-picker v-model="returnDate" valueType="format"
                           v-if="!englishDateEnabled"
              />
              <InputMask mask="9999-99-99" ref="tran" v-else class="nepali-calendar" id="returnDate"
                         v-model="returnDate"
              />
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="purchaseSalesDate">Date</label>
              <date-picker v-model="salesDate" valueType="format" v-if="!englishDateEnabled" disabled
              />
              <InputMask mask="9999-99-99" v-else class="nepali-calendar" id="purchaseSalesDate" v-model="salesDate"
                         disabled/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="billPrefix">Bill Prefix</label>
              <InputText id="billPrefix" v-model="billPrefix" disabled/>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="payMethod">Payment Method</label>
              <InputText id="payMethod" disabled v-model="paymentMethod"/>
            </div>
          </div>
          <div class="p-fluid p-formgrid p-grid p-mt-2">
            <div class="p-field p-col-12 p-md-4">
              <label>Contact Number: {{ contactNumber }}</label>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label>Bill Prefix: {{ customerName }}</label>
            </div>
          </div>
        </form>
        <div class="p-field p-col-12 p-md-12">
          <div class="row">
            <div class="scrollable">
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th>SN</th>
                  <th>Item Name</th>
                  <th>Purchased Qty</th>
                  <th>Remaining Qty</th>
                  <th>Return Qty</th>
                  <!-- <th>Unit</th> -->
                  <th>Rate</th>
                  <th>Amount</th>
                </tr>
                </thead>
                <tbody v-for="(item,index) in childSalesDetailsDTOList " :key="index">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.itemName }}</td>
                  <td>{{ item.quantity }}</td>
                  <td>{{ item.quantity - returnQty }}</td>
                  <td style="text-align:center">
                    <InputNumber onfocus="if (this.value === '0'){this.value = ''}" v-model="returnQty"
                                 @change="updateInventoryDetails(item.id,index)"/>
                  </td>
                  <!-- <td style="text-align:right">{{item.unitName}}</td> -->
                  <td style="text-align:right">{{ item.sellingPrice }}</td>
                  <td style="text-align:right">{{ item.sellingPrice * item.quantity }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <hr>
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-4">
            <label for="narration">Return Reason</label>
            <Textarea id="narration" rows="6" v-model="returnReason"></textarea>
          </div>
          <div class="p-field p-col-12 p-md-5"></div>
          <div class="p-field p-col-12 p-md-1">
            <Button icon="pi pi-save" class="p-button-raised p-button-success" label="Save"
                    @click.prevent="addSalesReturnBillWise"/>
          </div>
          <div class="p-field p-col-12 p-md-1">
            <Button class="p-button-raised p-button-danger" @click="goBack" label="Cancel"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'
import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import InputNumber from 'primevue/inputnumber'

export default {
  data() {
    return {
      billNumberList: [],
      returnDate: null,
      salesDate: null,
      loadPage: true,
      billPrefix: '',
      loading: false,
      returnQty: 0,
      returnReason: '',
      posSalesHeaderId: null,
      posSalesDetailList: [],
      childSalesDetailsDTOList: [],
      englishDateEnabled: true,
      paymentMethod: '',
      contactNumber: '',
      customerName: '',
      id: null
    }
  },
  mounted() {
    this.billNumbers()
  },
  methods: {
    async billNumbers() {
      let response = await this.$store.dispatch('posSalesBillNo')
      this.billNumberList = response.data.data
    },
    async searchInventoryDetailsByBillNo() {
      if (this.billPrefix === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select bill No!', life: 3000})
        return
      }
      this.loadPage = false
      this.loading = !this.loading
      let response = await this.$store.dispatch('posDetailByBillNo', this.billPrefix.billPrefix)
      this.loading = false
      this.posSalesDetailList = response.data.data
      if (this.posSalesDetailList.length > 0) {
        this.posSalesDetailList.forEach(data => {
          this.billPrefix = data.billPrefix
          this.posSalesHeaderId = data.id
          this.salesDate = data.salesDateNepali
          this.paymentMethod = data.paymentMethod
          this.contactNumber = data.contactNumber
          this.customerName = data.customerName
          this.childSalesDetailsDTOList = data.childSalesDetailsDTOList
        })
      }
      this.setDate()
    },
    updateInventoryDetails(id, index) {
      this.id = id
      // console.log(this.id)
      this.childSalesDetailsDTOList.forEach(invDetail => {
        if (invDetail.id === this.id) {
          if (this.returnQty > invDetail.quantity) {
            this.$toast.add({
              severity: 'error',
              summary: '',
              detail: 'Return quantity cannot be greater than purchased quantity!',
              life: 3000
            })
            return
          }
          invDetail.returnQty = this.returnQty
        }
        // this.childSalesDetailsDTOList.splice(index, 1, {...invDetail})
        // console.log(this.returnQty)
        // // debugger
        // console.log(this.childSalesDetailsDTOList.length)
      })
    },
    async addSalesReturnBillWise() {
      if (this.returnReason.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Return reason cannot be empty!', life: 3000})
        return
      }
      if (this.returnDate === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please enter date!', life: 3000})
        return
      }
      let returnObject = {
        id: this.posSalesHeaderId,
        billPrefix: this.billPrefix,
        transactionDate: this.returnDate,
        paymentMethod: this.paymentMethod,
        childSalesDetailsDTOList: this.childSalesDetailsDTOList,
        returnReason: this.returnReason
      }
      let response = await this.$store.dispatch('posSalesReturnBillWise', returnObject)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 3000})
      }
      this.goBack()
    },
    reset() {
      this.billPrefix = ''
    },
    setDate() {
      if (!this.loadPage) {
        this.checkEnglish()
        if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
          this.nepaliDate()
        }
        if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
          this.$store.state.isEnglishDateEnabled === 'false') {
          this.setNepaliDate()
        }
        if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
          this.setEnglishDate()
        }
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.purchaseSalesDate = this.$store.getters.nepaliNewDate
        this.returnDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#purchaseSalesDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.purchaseSalesDate = $('#purchaseSalesDate').val()
        }
      })
      $('#returnDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.returnDate = $('#returnDate').val()
        }
      })
    },
    setEnglishDate() {
      this.purchaseSalesDate = new Date().toISOString().slice(0, 10)
      this.returnDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    goBack() {
      this.loadPage = true
      this.returnQty = 0
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Button,
    InputMask,
    InputText,
    Textarea,
    InputNumber
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// posSalesReturnBillwise.vue?1e5b546e